import {
  Button, Form, InputNumber,
} from 'antd';
import { useParams } from 'react-router-dom';
import { useState } from 'react';
import DefaultModal from '../../../customer/components/modals/defaultModal/DefaultModal';
import formSetDynamicErrors from '../../../../utils/functions/formSetDynamicErrors';
import { adminRefundPaymentService } from '../../services/paymenSevices';

function AdminPaymentRefundModal({
  show, setShow, maxAmount, refetchData,
}) {
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const [form] = Form.useForm();

  const handleConfirm = async () => {
    setLoading(true);
    try {
      await adminRefundPaymentService(id, {
        amount: form.getFieldValue('amount'),
      });
      await refetchData();
      setShow(false);
    } catch (e) {
      formSetDynamicErrors({ form, e });
    } finally {
      setLoading(false);
    }
  };

  return (
    <DefaultModal
      show={show}
      setShow={setShow}
      className="ticket-refund-modal"
    >
      <div className="flex flex-col gap-5 items-center justify-center">
        <h3 className="text-center">
          შეიყვანეთ დასაბრუნებელი თანხა
        </h3>
        <Form
          form={form}
          layout="vertical"
          onFinish={handleConfirm}
        >

          <Form.Item
            label="თანხა"
            className="w-[300px]"
            name="amount"
            rules={[
              {
                required: true,
                message: 'შეიყვანეთ თანხა',
              },
            ]}
          >
            <InputNumber min={0} max={maxAmount} />
          </Form.Item>

          <div className="flex justify-center">
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
            >
              დადასტურება
            </Button>
          </div>
        </Form>

      </div>
    </DefaultModal>
  );
}

export default AdminPaymentRefundModal;
